/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from "react";
import { Row, Col, Menu, Dropdown, Button, message, Card } from "antd";
import { Link } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import { ChartCard } from "../../../components/widget";
import Layout from "../../../layouts/MocoLayout";
import oRest from "../../../apis/rest";
import config from "./index.config";
import useWindowDimensions from "../../../helper/viewport";

const API_URL = "webhook/dataquery/?qname=";

const menuCardStyle = {
  padding: 12,
  borderRadius: 16,
  color: "#fff",
  backgroundColor: "#1B6FBA",
  margin: "0px 12px 12px 0px",
  textAlign: "center",
};

const Page = () => {
  const [cards, setCards] = useState(config.cards);
  const [selectedAgama, setAgama] = useState("");
  const [selectedProvince, setProvince] = useState("");
  const [provinceMenu, setProvinceMenu] = useState([]);
  const agama = ["Khonghucu", "Hindu", "Buddha", "Kristen", "Katolik"];

  const { width } = useWindowDimensions();

  const toPascalCase = (params) => {
    return params.charAt(0).toUpperCase() + params.slice(1).toLowerCase();
  };

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}survey5agama_list_provinsi`;
      oRest
        .get(api)
        .then(({ data }) => {
          setProvinceMenu(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.sumberPendanaan.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => a.count - b.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              sumberPendanaan: {
                ...card.chart.sumberPendanaan,
                options: {
                  ...card.chart.sumberPendanaan.options,
                  chartOption: {
                    ...card.chart.sumberPendanaan.options.chartOption,
                    yAxis: {
                      ...card.chart.sumberPendanaan.options.chartOption.yAxis,
                      data: data.map((e) => e.sumber_biaya),
                    },
                    series: [
                      {
                        ...card.chart.sumberPendanaan.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.kondisiTempatIbadah.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => b.count - a.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              kondisiTempatIbadah: {
                ...card.chart.kondisiTempatIbadah,
                options: {
                  ...card.chart.kondisiTempatIbadah.options,
                  chartOption: {
                    ...card.chart.kondisiTempatIbadah.options.chartOption,
                    xAxis: {
                      ...card.chart.kondisiTempatIbadah.options.chartOption
                        .xAxis,
                      data: data.map((e) => e.sarana_tempatibadah),
                    },
                    series: [
                      {
                        ...card.chart.kondisiTempatIbadah.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.kondisiRuangIbadah.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => b.count - a.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              kondisiRuangIbadah: {
                ...card.chart.kondisiRuangIbadah,
                options: {
                  ...card.chart.kondisiRuangIbadah.options,
                  chartOption: {
                    ...card.chart.kondisiRuangIbadah.options.chartOption,
                    xAxis: {
                      ...card.chart.kondisiRuangIbadah.options.chartOption
                        .xAxis,
                      data: data.map((e) => e.sarana_ruangibadah),
                    },
                    series: [
                      {
                        ...card.chart.kondisiRuangIbadah.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.kondisiPerpustakaan.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => b.count - a.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              kondisiPerpustakaan: {
                ...card.chart.kondisiPerpustakaan,
                options: {
                  ...card.chart.kondisiPerpustakaan.options,
                  chartOption: {
                    ...card.chart.kondisiPerpustakaan.options.chartOption,
                    xAxis: {
                      ...card.chart.kondisiPerpustakaan.options.chartOption
                        .xAxis,
                      data: data.map((e) => e.sarana_perpustakaan),
                    },
                    series: [
                      {
                        ...card.chart.kondisiPerpustakaan.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.kelengkapanBuku.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.sort((a, b) => b.count - a.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              kelengkapanBuku: {
                ...card.chart.kelengkapanBuku,
                options: {
                  ...card.chart.kelengkapanBuku.options,
                  chartOption: {
                    ...card.chart.kelengkapanBuku.options.chartOption,
                    xAxis: {
                      ...card.chart.kelengkapanBuku.options.chartOption.xAxis,
                      data: data.map((e) => e.sarana_buku),
                    },
                    series: [
                      {
                        ...card.chart.kelengkapanBuku.options.chartOption
                          .series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  useEffect(() => {
    const fetchData = () => {
      const api = `${API_URL}${cards.chart.jumlahBuku.queryName}&agama=${selectedAgama}&provinsi=${selectedProvince}`;
      oRest
        .get(api)
        .then(({ data }) => {
          data = data.filter((e) => e.val !== -100);
          data = data.sort((a, b) => b.count - a.count);
          setCards((card) => ({
            ...card,
            chart: {
              ...card.chart,
              jumlahBuku: {
                ...card.chart.jumlahBuku,
                options: {
                  ...card.chart.jumlahBuku.options,
                  chartOption: {
                    ...card.chart.jumlahBuku.options.chartOption,
                    xAxis: {
                      ...card.chart.jumlahBuku.options.chartOption.xAxis,
                      data: data.map((e) => e.val),
                    },
                    series: [
                      {
                        ...card.chart.jumlahBuku.options.chartOption.series[0],
                        data: data.map((e) => e.count),
                      },
                    ],
                  },
                  dataSource: data.map((e, idx) => ({ ...e, id: idx })),
                },
                state: {
                  data,
                },
              },
            },
          }));
        })
        .catch((err) => {
          console.log(err);
          message.error("Terjadi kesalahan");
        });
    };
    fetchData();
  }, [selectedProvince, selectedAgama]);

  const handleFilterAgama = (value) => {
    setAgama(value.key === "all" ? "" : value.key);
  };

  const handleFilterProvinsi = (value) => {
    setProvince(value.key === "all" ? "" : value.key);
  };

  const agamaMenu = (
    <Menu onClick={handleFilterAgama}>
      <Menu.Item key="all">Semua Agama</Menu.Item>
      {agama.map((e) => {
        return <Menu.Item key={e}>{e}</Menu.Item>;
      })}
    </Menu>
  );

  const provinceDropdownMenu = (
    <Menu onClick={handleFilterProvinsi}>
      <Menu.Item key="all">Nasional</Menu.Item>
      {provinceMenu
        ?.map((e) => e.lembaga_provinsi)
        .sort((a, b) =>
          // eslint-disable-next-line no-nested-ternary
          a > b ? 1 : b > a ? -1 : 0
        )
        .map((e) => {
          return <Menu.Item key={e}>{toPascalCase(e)}</Menu.Item>;
        })}
    </Menu>
  );

  return (
    <Layout>
      <div
        style={{
          display: "flex",
          flexFlow: "row",
          flexWrap: "wrap",
          justifyContent: width > 795 ? "space-between" : "center",
        }}
      >
        <div>
          <Row justify={width > 795 ? "start" : "center"}>
            <Link to="/pendidikan-keagamaan/1" key="overview">
              <Col style={menuCardStyle}>
                <span className="text-default">Overview</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/2" key="lembaga">
              <Col style={menuCardStyle}>
                <span className="text-default">Lembaga</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/3" key="sdm">
              <Col style={menuCardStyle}>
                <span className="text-default">SDM</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/4" key="sarana">
              <Col style={menuCardStyle}>
                <span className="text-default">Sarana</span>
              </Col>
            </Link>
            <Link to="/pendidikan-keagamaan/5" key="pendidikan">
              <Col style={menuCardStyle}>
                <span className="text-default">Pendidikan</span>
              </Col>
            </Link>
          </Row>
        </div>
        <div>
          <Row justify={width > 795 ? "start" : "center"}>
            <Col>
              <Dropdown overlay={agamaMenu}>
                <Button
                  size="large"
                  shape="round"
                  style={{
                    backgroundColor: "#1B6FBA",
                    color: "#fff",
                  }}
                >
                  Pilih agama &nbsp;
                  <DownOutlined />
                </Button>
              </Dropdown>
            </Col>
            <Col>
              <Dropdown
                overlay={provinceDropdownMenu}
                overlayStyle={{ height: 300, overflowY: "auto" }}
              >
                <Button
                  size="large"
                  shape="round"
                  style={{
                    backgroundColor: "#1B6FBA",
                    color: "#fff",
                  }}
                >
                  Pilih provinsi &nbsp;
                  <DownOutlined />
                </Button>
              </Dropdown>
            </Col>
          </Row>
        </div>
      </div>
      <Row gutter={[24, 24]} style={{ paddingTop: "8px" }}>
        <Col span={24}>
          <Card
            style={{
              borderRadius: 16,
            }}
          >
            <span
              style={{
                fontSize: 26,
                fontWeight: 500,
                color: "#1B6FBA",
              }}
            >
              {`Sebaran Data ${
                selectedAgama === "" ? "Semua Agama" : `Agama ${selectedAgama}`
              } di ${
                selectedProvince === ""
                  ? "Seluruh Provinsi"
                  : `Provinsi ${selectedProvince}`
              }`}
            </span>
          </Card>
        </Col>
        <Col span={12} className="text-header" style={{ padding: "0 8px" }}>
          Statistik Sumber Pendanaan
        </Col>
        <Col span={12} className="text-header" style={{ padding: "0 8px" }}>
          Sarana & Prasarana Ibadah
        </Col>
      </Row>
      <Row gutter={[24, 24]}>
        <Col span={12} className="card_chart" style={{ padding: "0 8px" }}>
          <ChartCard {...cards.chart.sumberPendanaan} />
        </Col>
        <Col span={6} className="card_chart" style={{ padding: "0 8px" }}>
          <ChartCard {...cards.chart.kondisiTempatIbadah} />
        </Col>
        <Col span={6} style={{ padding: "0 8px" }}>
          <ChartCard {...cards.chart.kondisiRuangIbadah} />
        </Col>
      </Row>
      <Row gutter={[24, 24]} style={{ paddingTop: "8px" }}>
        <Col span={24} className="text-header" style={{ padding: "0 8px" }}>
          Sarana & Prasarana Literasi
        </Col>
      </Row>
      <Row gutter={[24, 24]} style={{ paddingBottom: "15px" }}>
        <Col span={6} className="card_chart" style={{ padding: "0 8px" }}>
          <ChartCard {...cards.chart.kondisiPerpustakaan} />
        </Col>
        <Col span={6} className="card_chart" style={{ padding: "0 8px" }}>
          <ChartCard {...cards.chart.kelengkapanBuku} />
        </Col>
        <Col span={12} style={{ padding: "0 8px" }}>
          <ChartCard {...cards.chart.jumlahBuku} />
        </Col>
      </Row>
    </Layout>
  );
};

export default Page;
